import Pagination from '../../../../components/Pagination';
import usePagination from '../../../../hooks/usePagination';
import useUserPositions from '../../../../hooks/web3/trade/useUserPositions';
import ExchangeListsErrowRow from '../ExchangeListsErrorRow';
import ExchangeListsStatus from '../ExchangeListsStatus';
import PositionRow from './PositionRow';

const headers = [
    'Type',
    'Size',
    'Collateral',
    'Entry Price',
    'Mark Price',
    'Liq. Price',
    'TP/SL',
    'PnL',
    '',
];

type PositionsProps = {
    rowPerPage: number;
};

const Positions: React.FC<PositionsProps> = ({ rowPerPage }) => {
    const { isLoading, userPositions, error } = useUserPositions();
    const pagination = usePagination(rowPerPage, userPositions?.length || 0);

    return (
        <>
            <div className='exchange-list-content positions'>
                <ExchangeListsStatus
                    isLoading={isLoading}
                    error={error}
                    message='positions'
                >
                    <div className='row header'>
                        {headers.map((header, index) => (
                            <div key={index}>{header}</div>
                        ))}
                    </div>
                    {userPositions && userPositions.length ? (
                        pagination
                            .paginateData(userPositions)
                            .map((position, index) => (
                                <PositionRow position={position} key={index} />
                            ))
                    ) : (
                        <ExchangeListsErrowRow message='You have no open positions' />
                    )}
                </ExchangeListsStatus>
            </div>
            {userPositions && userPositions.length > rowPerPage ? (
                <Pagination pagination={pagination} />
            ) : null}
        </>
    );
};

export default Positions;
